import moment from 'moment';
let startDt = moment().startOf('month').format('YYYY-MM-DD');
let endDt = moment().endOf('month').format('YYYY-MM-DD');

export default {
	/*클레임 현황 시작*/
	searchParams: SEARCH_PARAMS(),
	clamRepayList: [], //클레임 그리드 리스트
	prcsStepList: [], //조회조건 처리단계
	prcsRsltList: [], //조회조건 처리결과
	clmDdList: [], //조회조건 날자선택값
	ctypeList: [], //조회조건 ctype
	gridPrcStepList: [], //그리드안에 사용여부
	pagingInfo: PAGING_INFO(),
	/*클레임현황 끝*/

	/*클레임 신청현황 팝업관련 state 시작*/
	clamMstPopUp: CLAM_MST_POPUP(), //클래임신청 팝업조회
	saveClamMst: CLAM_MST_POPUP(), //클래임신청 저장State
	clamMstSwapPartsList: [], //쿨래암신청 교환부품정보
	ceqTypeList: [], //정비유형
	fileList: [], //파일첨부 디테일 조회할때
	occuRegnListPop: [], //클레임 신청팝업 PWA기초 정보 발생지역
	causCdListPop: [], //클레임 신청현황 PWA기초 정보 원인코드
	ctypeList: [], //클레임 신청현황 PWA기초 정보 Ctype
	tgrpYnList: [], //클레임 신청현황 변제대상
	isSaveFlag: false,
	prcStateCd: '',
	tmpCustSaleDd: '', //임시 고객판매일자
	tmpDgnDd: '', //임시 진단일자.
	/*클레임 신청현황 팝업관련 state 끝*/
	popupSearchParams: POPUP_SEARCH_PARAMS()
};

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

function SEARCH_PARAMS() {
	return {
		dlrCpnyCd: '' /*딜러점*/,
		causPartNo: '' /*품번*/,
		ctype: '' /*ctype*/,
		prcStepGb: '' /*처리단계*/,

		prcRsltCd: '' /*처리결과*/,
		prcClmDd: '' /* 검색날짜구분값*/,

		initStartDt: startDt /*초기값 시작from*/,
		initEndDt: endDt /*초기값 종료to*/,

		startDcsnDd: '' /*확정일자from*/,
		endDcsnDd: '' /*확정일자to*/,
		roNo: '' /*RO번호*/
	};
}

function CLAM_MST_POPUP() {
	return {
		clmNo: '', //클래임번호
		tgrpYn: '', //변제대상
		aplCpnyCd: '', //납품업체
		aplCpnyNm: '', //납품업체명
		dvswRt: '', //분담율
		aplDvswRt: '', //적용분담율
		rpymAmt: '', //변제금액
		aplRpymAmt: '', //적용변제금액
		prcsStepCl: '',
		prcsStepClNm: '',
		prcsRsltCl: '',
		prcsRsltClNm: '',
		aplcIdCl: '',
		aplcDdCl: '',
		dcsnIdCl: '',
		dcsnDdCl: '',
		aplCpnyNm: '',
		rmk: '',

		roNo: '', //RO번호
		prcsStepr: '' /* RO처리단계 */,
		aplcIdr: '' /* Ro신청자ID */,
		aplcDdr: '' /* RO신청일 */,
		dcsnIdr: '' /* RO확정자ID */,
		dcsnDdr: '' /* RO확정일 */,
		roFileId: '' /*RO전용 파일Id */,
		prcsRsltr: '', //Ro처리결과,
		prcsRsltNmr: '', //Ro처리결과명
		prcsStepNmr: '', //ro처리상태명
		cmpnNo: '', //캠페인번호
		cmpnNm: '', //캠페인명
		opCd: '', //op코드
		rptpNo: '', //고품분석번호
		mtrlCst: '', //자재비
		wags: '', //공임비
		incdCst: '', //부대비
		ceqStrtDd: '', //정비시작일
		ceqEndDd: '', //정비완료일

		ceqType: '', //정비유형
		pwaNo: '', //PWA번호
		prcsStepNm: '', //처리단계명
		prcStep: '', //처리단계
		aplcDd: '', //신청일
		dcsnDd: '', //확정일
		carVin: '', //VIN no
		pmcId: '', // pmdId
		vehlNm: '', //차종
		erpSaleDd: '', //HTWO판매일
		custNm: '', //판매사
		saleRegnNm: '', //판매지역
		flclSpcNm: '', //연료전지사양
		grntPlcy: '', //보증정책
		custSaleDd: '', //고객사판매일
		dlrCpnyCd: '', //딜러점코드
		dlrCpnyNm: '', //딜러점명
		rprRegn: '', //수리지역
		occuRegn: '', //발생지역
		dtlRegn: '', //지역세부
		causPartNo: '', //원인부품
		causPartNm: '', //원인부품명
		carTypeNm: '', //차종유형
		usePrd: '', //사용기간
		milg: '', //주행거리
		dgnDd: '', //진단일자
		causCd: '', //원인코드
		phmnCd: '', //현상코드
		phmnNm: '', //현상코드명
		ctype: '', //ctypeCd
		dtc1: '', //dtc1
		dtc2: '', //dtc2
		dtc3: '', //dtc3
		prtlSbc: '', //특이사항
		usePrdPo: '', //보증사용기간
		milgPo: '', //보증주행거리
		prcsRslt: '', //처리결과,
		fileId: '', //파일Id
		btnTsAuth: false, // 임시저장버튼권한
		btnApAuth: false, //신청버튼권한
		btnDelAuth: false, //삭제버튼권한
		btnApprAuth: false, //승인,반려,기각버튼권한
		readOnlyAuth: false, //리드온리구분값 신청일경우 입력못하게 함.
		readOnlyAuth1: false, //리드온리구분값 신청일경우 입력못하게 함.
		fileList: [], //파일첨부
		delFileList: [], //삭제할파일첨부
		custCplnSbc: '', //고객불만내용
		tclgDgns: '', //기술진단
		dtlSbc: '', //상세내용
		sgtn: '' //건의사항
	};
}

function POPUP_SEARCH_PARAMS() {
	return {
		dlrCpnyCd: '' /*딜러점*/,
		carVin: '' /*차량VIN*/,
		pwaNo: '' /*PWA번호*/,
		prcsRslt: '10' /*처리결과*/
	};
}

export { SEARCH_PARAMS, PAGING_INFO, POPUP_SEARCH_PARAMS, CLAM_MST_POPUP };
